import { createContext, useContext, useEffect, type ReactNode } from 'react'
import { themes, type ThemeId } from '@lds/shared'

type ThemeCtx = { theme: ThemeId; accentColor: string | null }
const Ctx = createContext<ThemeCtx>({ theme: 'editorial', accentColor: null })

export function ThemeProvider({
  theme,
  accentColor,
  children,
}: ThemeCtx & { children: ReactNode }) {
  useEffect(() => {
    const t = themes[theme]
    document.documentElement.style.setProperty('--bg', t.palette.bg)
    document.documentElement.style.setProperty('--fg', t.palette.fg)
    document.documentElement.style.setProperty('--ink', t.palette.fg)
    document.documentElement.style.setProperty('--accent', accentColor ?? t.palette.accent_default)
    document.documentElement.style.setProperty('--muted', t.palette.muted)
    document.documentElement.style.setProperty('--font-heading', t.fonts.heading)
    document.documentElement.style.setProperty('--font-body', t.fonts.body)
  }, [theme, accentColor])
  return <Ctx.Provider value={{ theme, accentColor }}>{children}</Ctx.Provider>
}

export function useTheme() {
  return useContext(Ctx)
}
